import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// Connects to data-controller="choices"
export default class extends Controller {
  static values = {
    defaultPlaceholder: { type: String, default: "Select an option" },
  };

  connect() {
    if (!this.choicesInstance) {
      // Check if select contains a blank option
      const placeholder = Array.from(
        this.element.querySelectorAll("option"),
      ).some((option) => {
        return option.value == "";
      });

      const options = {
        allowHTML: true,

        // If blank option present, allow it to be selected by enabling the remove item button
        removeItemButton: placeholder,
      };

      // Set default placeholder unless select contains a blank option
      if (!placeholder) {
        options.placeholderValue = this.defaultPlaceholderValue;
      }

      this.choicesInstance = new Choices(this.element, options);
    }
  }
}
